export const SYSTEM_MENU_IDS={
    MICore :1,
    MIBroker:295,
    Finance: 324,
    GICore:10000,
    GIPortal:10017,
    Security: 700,
    ComplaintsCore:20000,
    RICore:8001,
    CRMCore:800,
    MotorClaims:30000
};

export const SYSTEM_IDS={
    MICore :3,
    SSO: 1,
    MIBroker:4,
    GICore:6,
    ComplaintsCore:9,
    RICore:7,
    GIPortal: 8,
    CRM: 12,
    MotorClaims: 14,
};
export const ALLOWED_USERS={
a1:1,
a2:10309,
a3:11228,
a4:11227,
a5:11225,
a6:11224,
a7:11223,
a8:11222,
a9:11221,
a10:11220,
a11:10310,
a12:101,
a13:10269,
}